













import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Utils } from '@/utils/utils';
import { MessageInterface } from '../../interfaces/message/message.interface';

@Component({
  components: {},
})
export default class MessageItem extends Vue {
  @Prop() readonly message!: MessageInterface;

  get authorColor() {
    return Utils.getUserColor(this.message.author);
  }

  get authorInitial() {
    return this.message.author.charAt(0);
  }

  get content() {
    return this.message.message;
  }

  get authorName() {
    return this.message.author;
  }

  get messageClass() {
    return this.authorName === Utils.getCurrentUserName()
      ? 'message--right'
      : '';
  }
}
